import React, { useState, useEffect } from "react";
import Grid from "../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Box,
  Typography
} from "@mui/material";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import Search from "./Search";
import transactionAPI from "../../Network/Transaction";
import Title from "./Title";
import { selectRoles } from "../../reduxStore/RolesReducer";

import moment from "moment";
import { selectTransactionFilter } from "../../reduxStore/SettingsReducer";



import { SiMicrosoftexcel } from 'react-icons/si'
import { BsFilePdfFill } from 'react-icons/bs'
import mainUnitAPI from "../../Network/MainUnit";

const cookies = new Cookies();

const todayStart = new Date();
const yesterday = new Date(todayStart);
yesterday.setDate(yesterday.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

const todayEnd = new Date();
todayEnd.setHours(23, 59, 59, 999);
export default function ReportMainUnitSubscriptionLogs() {
  const [t] = useTranslation("common");
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [openFilterColumn, setOpenFilterColumn] = useState(false);
  const [openFilterColumnValue, setOpenFilterColumnValue] = useState([]);
  const [elementClicked, setElementClicked] = useState(null);

  const [filters, setFilters] = useState({
    company_name: "",
    receipt_number: "",
    creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
    creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
    creationDateFrom: yesterday,
    creationDateTo: todayEnd,
    export_excel: false,
    export_pdf: false,
    all_time: 1
  })
  const [reload, setReload] = useState(false)



  const [openForm, setOpenForm] = useState(false);
  const [openViewForm, setOpenViewForm] = useState(false);
  const [selectedObject, setselectedObject] = useState(null);
  const [showStops, setShowStops] = useState(false)
  const [showRoutes, setShowRoutes] = useState(false)

  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const controller = new AbortController();
  const [rowsTotal, setRowsTotal] = useState(0);
  const screenwidth = useSelector((state) => state.settingsData.screenwidth);

  const rolesRedux = useSelector(selectRoles)

  const [columns, setColumns] = useState([
    { field: "index_column", headerName: "ت", minWidth: 50, maxWidth: 60 },
    { field: "name_and_type", headerName: t("TRANSACTIONS.unit"), minWidth: 110, maxWidth: 150, flex: 2,
      renderCell: (rows) => {
        return (
          <Typography
              sx={{
                fontFamily: "Cairo-Bold",
                color: '#000000',
                fontWeight: 600,
                fontSize: '14px'
              }}
  
            >
              {getUnitFullPlate(rows)}
            </Typography>
          
  
  
        )
      }
    },
    { field: "is_subscribed_name", headerName: t("UNITS.is_subscribed"), flex: 1 },
    { field: "is_subscribed_note", headerName: t("UNITS.is_subscribed_note"),  flex: 2 },
    { field: "created_by_name", headerName: t("UNITS.created_by_name"), flex: 1 },
    { field: "formatted_datetime", headerName: t("UNITS.created_at"),  flex: 1},

  ])

  const getUnitFullPlate = (rows) => { 

    return ((rows?.row?.name_and_type?rows?.row?.name_and_type:"")
    +'\n'+(rows?.row?.plate_number?rows?.row?.plate_number:"")
    +(rows?.row?.plate_letter?rows?.row?.plate_letter:"")
    +'\n'+(rows?.row?.plate_province?rows?.row?.plate_province:"")
    +'\n'+(rows?.row?.plate_type?rows?.row?.plate_type:""))
   }



  useEffect(() => {

    loadData()


  }, [pageNumber, pageSize, reload]);


  const headerObject = {
    username: cookies.get("user_name") ? cookies.get("user_name") : null,
    user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
    account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
    account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
    authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
    sid: cookies.get("sid") ? cookies.get("sid") : null,
    baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
    id: cookies.get("id") ? cookies.get("id") : null,
  }
  const loadData = async (searchParams) => {



    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      let object = {
        ...headerObject,
        ...(filters?.export_excel || filters?.export_pdf ? {} :
          {
            page: pageNumber,
            page_size: pageSize,
          }),

        search: "",
        ...searchParams,
        ...filters,

      };



      setLoading(true);

      const result = await mainUnitAPI.mainUnitSubscriptionLogs({
        params: object,
        signal: controller?.signal,
      });
      setLoading(false);

      if (result.status && result?.data?.data) {


        if (filters?.export_excel) {
          setFilters({
            ...filters,
            export_excel: false
          })
          downloadExcel(result?.data?.data)
        }
        else if (filters?.export_pdf) {
          setFilters({
            ...filters,
            export_pdf: false
          })
          downloadPDF(result?.data?.data)
        }
        else {
          if (result?.data?.data?.data?.length > 0) {
            let data = []

            setRows(result?.data?.data?.data);
            setRowsTotal(result?.data?.data?.total_records);
            setPageCount(Math.ceil(result?.data?.data?.total_records / pageSize));
          }
          else {
            setRows([]);
            setRowsTotal(0);
            setPageCount(0);
          }
        }
      } else {
        setFilters({
          ...filters,
          export_pdf: false,
          export_excel: false
        })

        if (result?.data?.data?.message) {
          toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
        }
        else if (!result?.data?.error) {
          toast.error(t("NETWORK_MESSAGES.unknownError"));
          return;
        }
        if (result && result?.data && result?.data?.data?.message) {
          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }
        }
      }
      setLoading(false);
    } else {
      navigate("/redirect");
    }
  };

  const createFunction = () => {
    setselectedObject(null);
    setOpenForm(true);
  };



  const downloadPDF = async (data, transaction) => {
    const result = await transactionAPI.downloadPdf({
      params: {
        ...headerObject,
        fileName: data?.result
      }
    })
    setLoading(false)
    if (result.status && result?.data) {
      const url = window.URL.createObjectURL(new Blob([result?.data]));
      const link = document.createElement('a');
      link.href = url;
      let reportName = t('UNITS.report_for_main_units')

      link.setAttribute('download', reportName + '.' + data?.type);
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    }

  }
  const exportFunction = () => {

    setFilters({
      ...filters,
      export_excel: true
    })
    setReload(!reload)
  }
  const exportPDF = () => {
    setFilters({
      ...filters,
      export_pdf: true
    })
    setReload(!reload)
  }

  const clearFilterFunction = () => {
    setFilters({
      company_name: "",
      receipt_number: "",

      export_excel: false,
      export_pdf: false,
      creation_date_from: moment().subtract(1, "day").startOf("day").format('YYYY-MM-DD') + " 00:00:00",
      creation_date_to: moment().endOf('day').format('YYYY-MM-DD') + " 23:59:59",
      creationDateFrom: yesterday,
      creationDateTo: todayEnd,
      export_excel: false,

      all_time: 1
    })
  }
  const searchFunction = () => {
    setReload(!reload)
    setPageNumber(1)
  };

  const downloadExcel = async (fileName) => {
    const result = await transactionAPI?.downloadExcel({
      params: {
        ...headerObject,
        fileName: fileName
      }
    })
    if (result.status && result?.data) {
      var _url = window.URL.createObjectURL(result?.data);
      window.open(_url, "_blank").focus(); // window.open + focus
    }
  }

  const getTitleAndSecondaryTitle = () => {
    let title = t('REPORTS.subscription_logs_report')



    let secondaryTitle = ""

    return {
      title: title,
      secondaryTitle: secondaryTitle
    }
  }


  const getRowClassName = (params) => {


    if (params?.row?.rowStyleClassNumber) {

      return 'highlighted-gray-row'
    }
    else {
      return null
    }
  };
  return (
    <Box
      sx={{

        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "start",
        overflowX: "hidden",
        "& .MuiChip-label": {
          fontFamily: "Cairo-Medium",
        },
      }}
    >


      <Title
        title={getTitleAndSecondaryTitle()?.title}
        secondaryTitle={getTitleAndSecondaryTitle()?.secondaryTitle}
      />

      <Grid
        rows={rows}
        // multipleExports={rolesRedux?.export_transaction?.value ?
        //   [
        //     { icon: <SiMicrosoftexcel color="green" size={"25"} />, name: t('UNITS.exportExcel'), key: 'report1', onClick: () => { exportFunction() } },
        //     { icon: <BsFilePdfFill color="red" size={"25"} />, name: t('UNITS.exportPDF'), key: 'report4', onClick: () => { exportPDF() } },
        //   ] : []
        // }
        fixHeight={'calc(100vh - 300px)'}
        getRowClassName={getRowClassName}
        hasExport={true}
        exportFunction={exportFunction}
        columns={columns}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        loading={loading}
        handlePageChange={handlePageChange}
        rowsTotal={rowsTotal}
        checkScreenSize={screenwidth}
        pageCount={pageCount}
        openFilterColumn={openFilterColumn}
        elementClicked={elementClicked}
        setOpenFilterColumn={setOpenFilterColumn}
        setColumnFilterValue={setOpenFilterColumnValue}
        columFilterValue={openFilterColumnValue}

        clearFunction={clearFilterFunction}
        searchFunction={searchFunction}

        hasCreate={false}
        creatFunction={createFunction}

        hasColumnsHidShow={false}
        setColumns={setColumns}

        filterChilds={
          <Search
            filters={filters}
            setFilters={setFilters}
            showBySequence={
              {
                plate_number: 1,
                dateRange: 2
              }
            }


          />
        }
      />

    </Box>
  );
}
